import axios from 'axios';
import Actions from './actions';
import * as UTIL from '../../util';
var Creators = Actions.Creators;
var changeInput = Creators.changeInput;
var request = Creators.request;
var response = Creators.response;
var error = Creators.error;

function fetchNewsletter(state, values) {
  var apiVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return function (dispatch) {
    dispatch(request());
    var routeURL = UTIL.apiUtil.generateUrlForceVersion('marketing', 'addNewsletter', 'v2');
    return axios({
      method: 'put',
      headers: UTIL.apiUtil.setHeaders(),
      data: {
        'firstName': state.newsletter.firstName,
        'lastName': state.newsletter.lastName,
        'emailAddress': state.newsletter.emailAddress,
        'zipCode': state.newsletter.zipCode,
        'promotionId': values.promotionId
      },
      url: routeURL
    }).then(function (json) {
      dispatch(response(json));
    }).catch(function (err) {
      dispatch(error(err));
      console.log(err);
    });
  };
}

var postNewsletter = function postNewsletter(values) {
  var apiVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return function (dispatch, getState) {
    return dispatch(fetchNewsletter(getState(), values, apiVersion));
  };
};

export default {
  changeInput: changeInput,
  postNewsletter: postNewsletter
};